import { types } from './constants';

// TODO: State with mocked data for POC, need to think about an endpoint that returns

const INITIAL_STATE = {
  error: {
    code: null,
    details: null,
    message: null,
  },
  isFetching: true,
  selectedContent: null,
  isNextEpisode: false,
  zappingList: [],
  // Items the source content list already had loaded on click
  zappingSource: {
    widgetId: null,
    contents: [],
    isComplete: false,
  },
  // Episodios de temporada ya pedidos para el zapping de un EPISODE, cacheados
  // por serie+temporada para no volver a pedirlos al reentrar al player.
  zappingEpisodes: {
    key: null,
    contents: [],
  },
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CONTENT_SELECTED:
      return {
        ...state,
        selectedContent: action.content,
      };
    case types.WIDGET_FETCH:
      return {
        ...state,
        error: {
          ...INITIAL_STATE.error,
        },
        isFetching: true,
      };
    case types.WIDGET_FETCH_FAILURE:
      return {
        ...state,
        error: {
          ...action.error,
        },
        isFetching: false,
      };
    case types.WIDGET_FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        selectedContent: action.content,
      };
    case types.START_NEXT_EPISODE_SUCCESS:
      return {
        ...state,
        isNextEpisode: action.status,
      };
    case types.CLEAR_STATES:
      return {
        ...INITIAL_STATE,
        isNextEpisode: state.isNextEpisode,
        // Se conserva para no volver a pedir los episodios de la temporada
        // al navegar entre episodios (cada uno limpia el estado al montarse).
        zappingEpisodes: state.zappingEpisodes,
      };
    case types.ZAPPING_SOURCE_SET:
      return {
        ...state,
        zappingSource: {
          widgetId: action.widgetId,
          contents: action.contents || [],
          isComplete: !!action.isComplete,
        },
      };
    case types.ZAPPING_LIST_FETCH_SUCCESS:
      return {
        ...state,
        zappingList: action.contents,
      };
    // Without a zapping list the player simply doesn't show the button, so
    // an error here doesn't break playback.
    case types.ZAPPING_LIST_FETCH_FAILURE:
      return {
        ...state,
        zappingList: [],
      };
    case types.CLEAR_IS_NEXT_EPISODE_PLAYER:
      return {
        ...state,
        isNextEpisode: false,
      };
    case types.ZAPPING_EPISODES_FETCH_SUCCESS:
      return {
        ...state,
        zappingEpisodes: {
          key: action.key,
          contents: action.contents || [],
        },
      };
    // Without a zapping list the player simply doesn't show the button, so
    // an error here doesn't break playback. It's not cached: it's retried
    // the next time this season is requested.
    case types.ZAPPING_EPISODES_FETCH_FAILURE:
      return state;
    default:
      return state;
  }
};

export default reducer;
